import { Container, Heading, Flex, Divider } from '@chakra-ui/react';
import Breadcrumbs from '../../common/Breadcrumbs';
import PassDownloadTemplateForm from '../../components/client/pass-download-template/PassDownloadTemplateForm';
import { PassDownloadTemplateContextProvider } from '../../store/client/PassDownloadTemplateContext';
import UsePassDownloadTemplate from '../../hooks/usePassDownloadTemplate';

const PassDownloadTemplateEditPage = () => {
  const breadcrumbLinks = [
    {
      linkName: 'Home',
      linkUrl: '/',
    },
    {
      linkName: 'pass download pages',
      linkUrl: '/pass-download-pages',
    },
    {
      linkName: 'edit pass download page',
      linkUrl: null,
    },
  ];

  return (
    <PassDownloadTemplateContextProvider>
      <UsePassDownloadTemplate>
        <Container display="flex" flexDir="column" flex="1" pb={6}>
          <Breadcrumbs breadcrumbLinks={breadcrumbLinks} />
          <Flex
            flexDirection={{ base: 'column', sm: 'row' }}
            alignItems="center"
            flexWrap="wrap"
            mt="15px"
            py="9px"
            minH="54px"
          >
            <Heading>Edit pass download page</Heading>
          </Flex>
          <Divider borderColor="primaryBackground" mb={6} />
          <PassDownloadTemplateForm isEdit />
        </Container>
      </UsePassDownloadTemplate>
    </PassDownloadTemplateContextProvider>
  );
};

export default PassDownloadTemplateEditPage;
